import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { filterToValidAttributes } from '@zocdoc/dom-property';
import { Metrics } from '@zocdoc/frontend-metrics';

import LegalContent from './Legal';
import LinkFarmContent from '../Links';
import SupportContent from './Support';
import { breakpoint } from '../../grid';
import { FontFamily } from '../../typography';

const StyledFooter = styled.footer`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    font: 12px ${FontFamily.SharpSansSemibold};

    *, *::before, *::after {
        box-sizing: border-box;
    }

    > * {
        flex-shrink: 0;
    }

    ${breakpoint.medium} {
        font-size: 15px;
    }
`;

const StyledLinkFarmContent = styled(LinkFarmContent)`
    ${breakpoint('small', { down: true })} {
        display: none;
    }
`;

export class Footer extends PureComponent {
    static propTypes = {
        onSupportLinkClick: PropTypes.func,
        onSeoLinkClick: PropTypes.func,
        onLegalLinkClick: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }),
        theme: PropTypes.shape({
            footer: PropTypes.shape({
                showLegal: PropTypes.bool,
                showSEO: PropTypes.bool,
                showSupport: PropTypes.bool,
                showPricingLink: PropTypes.bool,
            }),
        }).isRequired,
    }

    maybeRenderLegal(showLegal) {
        if (showLegal) {
            return (
                <Metrics section="LegalFooter">
                    <LegalContent
                        location={this.props.location}
                        trackLinkClick={this.props.onLegalLinkClick}
                    />
                </Metrics>
            );
        }
    }

    maybeRenderSupport(showSupport) {
        if (showSupport) {
            return (
                <Metrics section="ServiceBanner">
                    <SupportContent trackLinkClick={this.props.onSupportLinkClick} />
                </Metrics>
            );
        }
    }

    maybeRenderSEOLinks(showSEO, showPricingLink) {
        if (showSEO) {
            return (
                <Metrics section="ZocdocFooter">
                    <StyledLinkFarmContent
                        showBadges
                        showCities
                        showCtas
                        showPricingLink={showPricingLink}
                        showSeo
                        showSpecialties
                        showZocdocLinks
                        trackLinkClick={this.props.onSeoLinkClick}
                    />
                </Metrics>
            );
        }
    }

    render() {
        const { children, theme: { footer }, ...props } = this.props;
        return (
            <StyledFooter {...filterToValidAttributes(props)}>
                {this.maybeRenderSupport(footer.showSupport)}

                {children}

                {this.maybeRenderSEOLinks(footer.showSEO, footer.showPricingLink)}
                {this.maybeRenderLegal(footer.showLegal)}
            </StyledFooter>
        );
    }
}

export default withRouter(withTheme(Footer));
